module.exports = __webpack_public_path__ + "img/pr-2.7cfcc5b5.png";